import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	viewActiveIncidents: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewActiveIncidents: {
		id: 'issue-field-service-entity.common.active-incidents-indicator.view-active-incidents',
		defaultMessage: 'View open incidents',
		description: 'Button to open a popup to show the open incidents',
	},
});
export default messages;
